exports.default = {
  history_empty: '暂无视频历史对话',
  history_load_more: '加载更多',
  cases_ui: {
    "audio": "音频",
    "gallery_eyebrow": "灵感 · 创作过程",
    "gallery_title": "视频案例",
    "gallery_description": "从分镜图片到成片，看看一个创意如何在对话中完成。",
    "categories": "案例分类",
    "all_categories": "全部案例",
    "search": "搜索视频案例",
    "search_submit": "搜索",
    "sort": "案例排序",
    "recommended": "精选推荐",
    "latest": "最新发布",
    "popular": "热门案例",
    "loading_cases": "正在加载视频案例",
    "loading_detail": "正在加载案例与创作过程…",
    "cases_failed": "暂时无法加载视频案例，请重试。",
    "detail_failed": "案例暂时无法查看，可能已下架或链接已失效。",
    "categories_failed": "分类暂时无法加载，仍可浏览全部案例。",
    "empty_cases": "视频案例正在准备中",
    "empty_cases_hint": "这里将展示视频成品，以及从图片分镜到视频的完整创作过程。",
    "empty_search": "没有找到匹配案例，试试其他关键词或分类。",
    "clear_filters": "清除筛选",
    "total": "{count} 个案例",
    "untitled": "未命名视频案例",
    "open_case": "查看案例：{title}",
    "view_process": "查看创作过程",
    "process_label": "对话中的创作",
    "detail_title": "视频创作案例",
    "read_only": "只读展示 · 不会执行历史任务或产生生成费用",
    "conversation": "创作对话",
    "preview": "成品预览",
    "outputs": "生成成品",
    "filter_media": "筛选成品类型",
    "all": "全部",
    "image": "图片",
    "video": "视频",
    "reference": "参考素材",
    "user": "用户",
    "assistant": "AI 助手",
    "prompt": "提示词",
    "empty_conversation": "此案例未提供可公开的对话记录。",
    "empty_media": "暂无可预览的成品。",
    "empty_filter": "此类型暂无成品。",
    "select_media": "查看第 {index} 项{type}",
    "media_failed": "素材暂时无法播放或显示，请重试。",
    "continue_chat": "继续对话",
    "continuing": "正在准备会话…",
    "continue_unavailable": "此案例没有可继续的会话上下文，仍可查看成品。",
    "continue_failed": "暂时无法继续对话，请重试。不会自动发送消息或生成视频。",
    "make_same": "做同款",
    "make_same_notice": "提示词和当前模型支持的参数已填入，尚未发送。来源参考素材未导入；需要完整素材和上下文，请使用案例中的“继续对话”。",
    "close": "关闭",
    "dismiss": "知道了",
    "retry": "重试",
    "share_failed": "分享内容暂时无法加载，请重试。"
  },
  execution_regenerate_forbidden: "视频执行这一轮不支持重新回答。可刷新查看原任务，或重新报价并确认生成新视频。",
  retry_prepare_failed: "重新回答准备失败，未发起新回答，请重试。",
  execution_loading: "正在准备视频生成任务…",
  task_loading: "正在读取视频任务…",
  task_media_pending: "视频已生成，正在获取播放地址",
  execution_failed: "这条视频未能提交，请查看本次执行回复中的说明。",
  execution_unconfirmed: "这条视频的执行状态尚未确认，正在核实原任务，请勿重复生成。",
  execution_refresh_failed: "暂时无法更新视频状态，已保留当前结果，可刷新重试。",
  title_brand: 'PAITEAMS',
  title: 'AI 视频创作',
  back: '返回',
  entry_title: '选择视频入口',
  entry_caption: '聚合入口',
  entry_default_desc: '统一调度视频生成能力',
  video_entry: '视频创作',
  model_title: '选择视频智能体',
  video_model: '视频模型',
  model_default_desc: '适合镜头、动作与场景生成',
  active: '已启用',
  config_title: '视频参数',
  config_caption: '跟随智能体配置',
  seconds: '秒',
  advanced: '输出选项',
  sound: '声音',
  outputs: '个输出',
  declared: '已声明',
  pending: '待支持',
  pending_adapter: '当前执行适配器尚未启用此选项',
  config_note: '当前基础链路提交时使用时长、分辨率和比例；声音与 K 数待执行适配器接入后启用。',
  skill_title: '视频技能与预设',
  optional: '可选',
  composer_kicker: 'VIDEO BRIEF',
  composer_title: '描述你想看到的画面',
  ready: '已就绪',
  waiting: '等待配置',
  choose_model: '请选择视频智能体',
  choose_config: '先选择一个视频智能体',
  reference: '参考图片',
  reference_hint: '可选，帮助保持主体和风格一致',
  generate: '开始生成',
  send_message: '发送给智能体',
  previous_quote_notice: '以下为历史报价或任务，按卡片内的原始参数处理；发送新消息不会确认、取消或重新提交它。',
  creating: '正在进入智能体对话',
  no_entry: '暂无可用的视频入口',
  no_models: '暂无可用的视频智能体',
  conversation_failed: '无法创建视频会话，请稍后重试。',
  new_conversation: '视频生成会话',
  auth_notice: '登录后即可选择视频智能体并开始创作。',
  login: '登录',
  load_failed: '视频智能体暂时无法加载，请稍后重试。',
  back_home: '返回首页',
  agent: '视频智能体',
  choose_agent: '选择视频智能体',
  no_entry_agents: '暂无可用的视频入口智能体',
  no_video_agents: '暂无可用的视频模型',
  loading: '加载视频配置中',
  load_failed: '视频配置加载失败',
  retry: '重试',
  prompt_label: '描述你想生成的视频',
  prompt_placeholder: '例如：一段 8 秒的产品开箱短片，镜头平稳，光线自然。',
  reference_images: '参考图片',
  add_reference: '添加参考图',
  remove_reference: '移除参考图',
  settings: '视频参数',
  duration: '时长',
  select_duration: '选择视频生成时长',
  duration_range_hint: '时长需在 {min} - {max} 秒内',
  seconds_short: '秒',
  resolution: '分辨率',
  aspect_ratio: '画面比例',
  frame_adaptive_ratio: '自动比例',
  reference_all: '全能参考',
  first_last_frame: '首尾帧参考',
  audio: '声音',
  generation_count: '生成数量',
  output_count: '输出数量',
  enabled: '开启',
  disabled: '关闭',
  adapter_unavailable: '当前执行适配器暂不支持此参数',
  skills: '视频技能',
  presets: '分类预设',
  cases: '案例',
  recent: '最近创作',
  empty_cases: '暂无案例',
  empty_recent: '暂无视频会话',
  start: '开始创作',
  continue_chat: '进入对话工作台',
  select_agent_first: '请先选择视频智能体',
  prompt_required: '请输入视频描述',
  agent_unavailable: '当前视频智能体不可用，请刷新配置',
  config_source: '参数来自当前智能体配置',
  model: '模型',
  default_config: '默认配置',
  video_agent: '视频智能体',
  skill_selected: '已选择技能',
  preset_selected: '已选择预设',
  case_selected: '已填充案例',
  chat_handoff_failed: '无法打开视频对话，请稍后重试',
  signed_in_required: '登录后才能开始视频创作',
  video_preview: '视频预览',
  play: '播放',
  pause: '暂停',
  download: '下载',
  download_preparing: '准备下载...',
  download_failed: '下载链接获取失败，点击重试',
  download_unavailable: '当前视频暂不支持下载',
  download_expired_refresh: '下载链接已过期，请刷新页面后重试',
  download_ready_click: '下载链接已就绪，请再次点击下载按钮',
  task_title: '视频生成',
  task_generating: '视频正在生成',
  task_ready: '视频已生成',
  task_failed: '视频生成失败',
  task_failed_detail: '请稍后重试或调整描述后重新生成。',
  task_status_pending: '等待处理',
  task_status_running: '正在生成',
  task_status_ready: '生成完成',
  task_status_failed: '生成失败',
  task_status_cancelled: '已取消',
  task_status_unknown: "任务状态未知",
  task_parameters: {
    type: "任务类型",
    reference: "参考生成",
    edit: "原片编辑",
    follow_source_duration: "跟随原片时长",
    follow_source_duration_value: "跟随原片时长（{seconds} 秒）",
    adaptive_ratio: "自动选择比例",
    follow_source_ratio: "跟随原片比例",
    follow_source_ratio_value: "跟随原片比例（{ratio}）",
    source_video: "原片",
    source_dimensions: "原片 {width} × {height}"
  },
  batch: {
    decision_declined: "本次不生成，未预占积分。",
    progress: "已确认 {total} 个视频 · 完成 {completed} 个 · 失败或取消 {failed} 个",
    title: "视频报价方案",
    member_count: "{count} 个独立视频",
    status_collecting: "报价收集中",
    status_ready: "请选择生成范围",
    status_decided: "已提交决定",
    status_invalidated: "历史报价",
    status_cancelled: "已取消",
    collecting_notice: "正在收集同一批次的报价。批次准备完成后才能选择和确认。",
    selection_label: "选择本次要生成的视频",
    untitled: "视频方案",
    hold: "本次预占",
    parameters: "生成规格",
    points: "{points} 积分",
    seconds: "{seconds} 秒",
    script_source: "脚本：{title} · 第 {revision} 版",
    prompt_source: "来源：直接描述",
    input_snapshot: "查看生成内容",
    input_unavailable: "生成内容暂不可用",
    associations: "查看来源与任务关联",
    quote_id: "报价 ID",
    batch_id: "批次 ID",
    script_id: "脚本 ID",
    decision_id: "决定 ID",
    dispatch_id: "提交 ID",
    task_id: "任务 ID",
    select_all: "全选",
    clear_selection: "取消勾选",
    selected_count: "已选 {count} 项",
    total_hold: "合计预占",
    selected_total: "已选 {count} 个视频 · 合计预占 {points} 积分",
    balance: "团队可用积分：{points}",
    balance_unknown: "待核验",
    insufficient_points: "所选预占积分超过团队可用余额。请减少选择或补充积分；最终以服务端校验为准。",
    decision_notice: "确认后预占所选视频的积分，未选视频本次不生成。",
    reject_all: "本次不生成",
    confirm_selected: "确认生成",
    retry_same_decision: "重试",
    settlement_not_ready: "该报价暂无法确认，本次未预占积分。请重新获取报价后再确认。",
    verify_failed: "报价加载失败，请刷新重试。",
    scope_changed: "当前账户、团队或会话无法访问此批次。",
    quote_changed: "报价版本、价格或成员已变化，请刷新并重新检查选择。",
    action_failed: "操作未完成，请刷新后重试。",
    recovery_unavailable: "无法保存操作记录，请允许浏览器存储后刷新重试。",
    decision_verify_failed: "状态更新失败，请刷新重试。",
    sync_pending: "状态同步中",
    sync_conflict: "同步冲突，待核验",
    confirmed_notice: "已确认，等待 AI 按本次报价继续执行。",
    quote_confirmation_required: "待确认",
    quote_confirmed: "已确认",
    quote_consumed: "已使用",
    quote_rejected: "未通过 · 本次不生成",
    quote_invalidated: "已失效",
    quote_cancelled: "已取消",
    quote_unpriced: "暂无法报价",
    decision_saved: "已确认。",
    decision_committed: "已确认，等待生成。",
    decision_waiting_sync: "确认已保存，正在同步；同步完成后由 AI 继续执行。",
    decision_pending_ai: "已确认，等待 AI 执行。",
    decision_running_ai: "AI 正在处理已确认方案。",
    decision_retry_wait: "等待恢复原 AI 执行意图。",
    decision_cancelled: "本次操作已取消。",
    decision_expired: "等待已结束，请刷新查看。",
    decision_needs_attention: "生成状态待确认，请刷新查看。",
    reason_user_declined: "本次决定未选择此方案，不生成视频，也不产生任务费用。",
    reason_quote_not_latest_round: "新的普通消息已关闭这轮待确认报价，请让 AI 重新报价。",
    reason_superseded: "此报价轮次已成为历史。",
    reason_target_replaced: "该目标已被新报价替代。",
    reason_script_revision_changed: "脚本已有新版本，需要重新报价。",
    reason_pricing_changed: "价格规则已变化，需要重新报价。",
    reason_unavailable: "此方案需要刷新正式状态或重新报价。",
    task_unknown_notice: "原任务的提交状态未知，继续查询原任务；不视为失败、退款或新的生成授权。"
  },
  quote: {
    legacy_read_only: "旧版报价仅供查看与恢复原任务。需要生成新视频时，请在聊天中重新报价。",
    estimate_summary: '预计 {points} 积分，按实际结算',
    estimate_consent: '确认即同意按实际费用结算：先预占预计积分；实际费用低于预计时自动退差，高于预计时自动补扣差额，团队可用积分可能变为负数。确认时预计积分超过团队可用积分，服务端会阻止提交。',
    actual_base: '实际基础费用（不含人工调整）',
    provisional_deducted: '预计暂扣（当前净额）',
    net_deducted: '当前净扣费',
    net_credit: '当前净返还',
    estimate_difference: '实际费用与预计差额',
    charged_total: '累计扣费',
    refunded_total: '累计退款',
    supplemental_total: '累计补扣',
    adjustment: '人工调整（正为补扣，负为退款）',
    settlement_source: '结算依据',
    source_unavailable: '等待结算依据',
    source_provider_cost: '已核验供应商费用',
    source_provider_usage: '已核验供应商用量',
    source_verified_spec: '已核验成功输出规格',
    source_estimate: '预计费用（非实际用量）',
    billing_status_provisional: '计费：预计暂扣',
    billing_provisional: '已按预计 {points} 积分暂扣，当前预占 {held} 积分。实际费用尚未知；可信费用到达后会自动退差或补扣，人工调整会保留。自动刷新有次数限制，之后仍可手动刷新或回到页面核验。',
    billing_settled_v2: '实际基础费用已核验为 {points} 积分；当前净扣费或净返还、人工调整及累计退款见上方。原始预占已关闭，释放 {released} 积分，当前预占 {held} 积分。释放预占不是累计退款，也不一定增加可用余额；过期或已停用额度不会恢复。',
    billing_calculated_v2: '待核验基础费用：{points} 积分，尚不是最终实际费用；已扣或已退金额以上方净额为准。',
    billing_reason_estimate_fallback: '实际费用尚未到达，当前按预计暂扣；收到可信实际费用后自动结算差额，不把预计当作实际用量。',
    billing_reason_waiting_output: '生成成功通知已核验，正在等待任务视频保存完成；当前尚未扣费，预占继续保留，服务端会继续核验。',
    dispatch_pending_v2: '确认后先预占预计 {points} 积分，再由服务端提交一个视频任务；预占不是扣费，后续按实际费用自动结算。',
    reservation_pending_v2: '确认后先预占预计 {points} 积分，而非扣费。生成提交尚未开放；后续结算以已确认的实际费用规则为准。',
    confirm_generate_v2: '确认预计 {points} 积分并生成',
    confirm_reserve_v2: '确认并预占预计 {points} 积分',
    insufficient_points_v2: '预计积分超过团队可用积分，服务端已阻止确认提交，未扣费。不会自动重试，请先刷新报价状态。',
    actual_deducted: "实际已扣积分",
    committed: "已确认扣除积分",
    settled_at: "结算时间",
    billing_status_not_started: "计费：未开始",
    billing_status_reserved: "计费：已预占",
    billing_status_awaiting_usage: "计费：等待用量",
    billing_status_settled: "计费：已结算",
    billing_status_released: "计费：提交前已释放",
    billing_status_manual_review: "计费：待人工复核",
    billing_status_unpriced: "计费：暂无法定价",
    billing_status_unavailable: "计费状态待核验",
    billing_awaiting_usage: "正在等待可信用量以完成结算，当前仍预占 {held} 积分。视频就绪不代表计费已结算，仍可刷新核验。",
    billing_settled: "已核验结算：实际扣除 {points} 积分，释放预占 {released} 积分，当前预占 {held} 积分。释放不一定增加团队可用余额，过期或已停用额度不会恢复。任务进度与结算状态相互独立。",
    billing_manual_review: "计费需要人工复核，当前保留预占 {held} 积分，尚未扣费。不能视为已退款，请勿重复提交。自动计费刷新已暂停，仍可手动刷新。",
    billing_unpriced: "实际用量暂无法安全定价，当前保留预占 {held} 积分，尚未扣费。未知用量不代表免费生成或已退款，仍可手动刷新。",
    billing_calculated: "待复核测算积分：{points}。这不是已扣金额，也不代表授权超出最高额度扣费。",
    billing_reason_usage_missing: "缺少可信用量，不能按零用量处理，也不能视为预占已退回。",
    billing_reason_authorization_exceeded: "测算用量超过授权上限，需要复核；不推定额外扣费或退款。",
    billing_reason_settlement_policy_unconfigured: "冻结的计费策略不允许自动结算，需要复核。",
    billing_reason_failure_requires_review: "任务结果需要计费复核；生成失败本身不会释放预占。",
    billing_reason_estimated_usage: "估算用量不能用于最终结算，需要可信用量或人工复核。",
    billing_reason_usage_source_untrusted: "用量尚未通过结算核验，预占继续保留。",
    billing_reason_usage_conflict: "用量信息存在冲突，需复核后才能结算。",
    billing_reason_currency_mismatch: "计费信息与冻结报价不一致，需要复核。",
    billing_reason_manual_review: "计费需要人工复核，不能推定自动退款。",
    billing_reason_unpriced: "计费暂无法安全定价，不代表免费生成。",
    billing_reason_unavailable: "计费仍需核验，请以上方已核验金额为准，不推定扣费或退款。",
    billing_reason_multiple_final_usage: "存在多个最终用量记录，需复核后才能结算。",
    billing_reason_usage_payload_conflict: "用量记录存在冲突，需复核后才能结算。",
    billing_reason_retries_exhausted: "自动计费核验未能完成，需要人工复核。",
    billing_reason_invariant_violation: "暂无法核验计费一致性，不推定扣费或退款。",
    billing_reason_invalid_pricing: "冻结的计价规则暂无法对本次用量安全定价。",
    reason_dispatch_expired: "提交授权已过期，服务端已在提交前取消任务并释放预占；如需生成，请重新获取报价并确认。",
    confirm_generate: "确认预占并提交生成",
    dispatch_pending: "确认后将预占最高 {points} 积分，再由服务端排队提交单个视频生成任务；预占不是扣费。",
    dispatch_held: "当前仍预占 {points} 积分。提交状态或任务完成均不代表已扣费；仅以服务端核验结果为准，不因报价到期自动释放。",
    dispatch_status_queued: "已排队",
    dispatch_status_submitting: "正在提交",
    dispatch_status_accepted: "已受理",
    dispatch_status_unknown: "提交状态未知",
    dispatch_status_rejected: "提交被拒绝",
    dispatch_status_cancelled: "提交已取消",
    dispatch_queued: "已预占并排队，尚未开始提交时可取消；若工作进程已开始提交，则不能取消。",
    dispatch_submitting: "服务端正在提交生成任务，当前不可取消。积分继续预占。",
    dispatch_accepted: "生成请求已受理，不代表视频已完成或已扣费。请以下方已核验任务的进度与结果为准。",
    dispatch_unknown: "无法确定提交结果，当前不可取消。积分继续预占；请刷新服务端状态，不要重复提交。",
    dispatch_rejected: "服务端已确认提交被拒绝，此报价已失效；预占已释放，释放结果以下方积分记录为准。",
    dispatch_cancelled: "服务端已确认在提交前取消并释放预占；不会恢复已过期的积分。",
    reason_dispatch_rejected: "提交被拒绝，原报价已失效。如需重新生成，请获取新报价并再次明确确认。",
    task_verify_failed: "暂时无法核验当前报价的任务归属或进度，未展示未核验结果。请刷新状态；预占不会因此释放。",
    active_quote_retained: "当前报价仍有预占、生成任务或待核验操作结果，已保留原始快照。修改输入不会取消它，也不会再次提交生成。",
    dispatch_state_unknown: '暂时无法安全释放预占，尚未核验到取消或释放成功。保留上次核验的预占信息，请刷新报价状态；不会自动重试。',
    reason_reservation_unavailable: '预占记录不可用，此报价已失效，请重新获取并核对报价。',
    confirm_reserve: '确认并预占最高 {points} 积分',
    cancel_release: '取消并释放 {points} 积分',
    held: '当前预占（未扣费）',
    released: '已释放预占积分',
    reservation_id: '预占编号',
    reservation_pending: '确认后将预占最高授权的 {points} 积分，预占不是扣费。视频生成仍被阻止，不会自动提交。',
    reservation_held: '当前预占 {points} 积分，尚未扣费。视频生成仍被阻止，尚未开始。',
    reservation_released: '已释放预占 {points} 积分，当前预占 {held} 积分。实际可用积分以团队余额为准，过期或已停用额度不会恢复；未扣费，也未开始生成。',
    reservation_none: '此报价未预占或扣除积分，也不会启动视频生成。',
    expiry_release_pending: '本地显示报价已到期，但服务端上次核验仍有预占。请刷新状态或取消报价以核验释放，不能视为已释放。',
    insufficient_points: '可用积分不足，无法预占最高授权积分。本次确认未成功，未扣费；不会自动重试，请先刷新报价状态。',
    refresh_status: '刷新报价状态',
    reason_billing_policy_changed: '预占策略已变化，此报价已失效，请重新获取并核对报价。',
    title: '视频报价确认',
    create: '获取视频报价',
    creating: '正在为当前输入准备报价',
    verifying: '正在核验报价归属与最新状态',
    confirm: '确认此报价',
    cancel: '取消报价',
    estimated: '预计积分',
    maximum: '最高授权积分',
    points: '{points} 积分',
    unavailable: '暂无',
    model_unavailable: '模型暂不可用',
    status_confirmation_required: '待确认',
    status_confirmed: '已确认，待提交',
    status_cancelled: '已取消',
    status_invalidated: '已失效',
    status_expired: '已过期',
    status_unpriced: '暂无法报价',
    no_execution: '当前仅记录报价确认，未预占或扣除积分，也不会启动视频生成。',
    single_output_notice: '当前报价仅支持单个视频输出，不支持音频开关。',
    confirmed_pending: '确认已记录，待提交。视频生成尚未开始。',
    page_snapshot: '此报价对应卡片内保存的输入，与上方新消息无关；新的视频工具请求需要另行报价确认。',
    skill_snapshot: '技能可能改写提示词。此报价仅对应下方提示词快照，不代表 AI 最终请求报价。',
    quote_changed: '报价已变化，请核对最新参数与积分后再次确认。',
    inputs_changed: '参数或参考素材已变化，此报价不能继续确认。',
    scope_changed: '账号或团队已变化，此报价在当前会话中不可用。',
    create_failed: '暂时无法获取确认报价，请使用当前输入重试。',
    tool_unavailable: '视频报价暂不可用，未记录确认，也未开始生成。',
    verify_failed: '无法核验此报价，核验成功前不可确认。',
    action_failed: '无法核验操作结果，请刷新服务端状态后再试。',
    prompt_required: '请输入非空提示词以获取报价。',
    prompt: '提示词快照',
    reference_mode: '参考模式',
    references: '参考素材',
    no_references: '无',
    breakdown: '报价明细',
    item: '项目 / 单位',
    quantity: '数量',
    billable_quantity: '计费数量',
    expires: '有效期至',
    rule_version: '计价规则版本',
    confirmed_at: '确认时间',
    reason_context_changed: '模型、输入或参考素材已变化，请重新获取报价。',
    reason_pricing_changed: '计价规则已变化，请重新获取报价。',
    reason_superseded: '此报价已被新报价替代，请核对最新报价后确认。',
    reason_quote_expired: '报价已过期，请重新获取报价。',
    reason_unavailable: '此报价当前不可确认。'
  },
  constraints: {
    "error_dialog_title": "素材不符合当前模型要求",
    "error_acknowledge": "知道了",
    "error_reference": "素材 {index}：{name}",
    "details": {
      "unsupported_file": "不支持此媒体类型或格式。",
      "frames_images": "首尾帧只能使用图片。",
      "type_count": "当前模型最多允许 {max} 项此类素材。",
      "format": "不支持格式 {actual}，允许：{allowed}。",
      "empty_file": "文件为空。",
      "size": "大小 {actual} 字节超过 {max} 字节上限。",
      "size_exclusive": "大小必须小于 {max} 字节，当前 {actual} 字节。",
      "minimum": "{field}为 {actual}，最小要求 {min}。",
      "maximum": "{field}为 {actual}，最大允许 {max}。",
      "codec": "不支持{field} {actual}，允许：{allowed}。"
    },
    "model_rules": "当前选择上限为 {max} 项；各类型数量及媒体要求分别校验。50 仅为系统安全上限，不是模型官方联合总上限。",
    "checking": "正在读取本地文件元数据…",
    "unnamed": "未命名文件",
    "total_count": "已选 {actual} 项参考素材，当前上限为 {max} 项。请主动移除素材或切换模型，已有选择已保留。",
    "mode": "当前模型不支持「{mode}」，已有参考素材已保留。",
    "unsupported_file": "第 {index} 项「{name}」：不支持此媒体类型或格式。",
    "frames_images": "第 {index} 项「{name}」：首尾帧只能使用图片。",
    "type_count": "第 {index} 项（{type} {typeIndex}）「{name}」：当前模型最多允许 {max} 项此类素材。",
    "format": "第 {index} 项（{type} {typeIndex}）「{name}」：不支持格式 {actual}，允许：{allowed}。",
    "empty_file": "第 {index} 项（{type} {typeIndex}）「{name}」：文件为空。",
    "size": "第 {index} 项（{type} {typeIndex}）「{name}」：大小 {actual} 字节超过 {max} 字节上限。",
    "size_exclusive": "第 {index} 项（{type} {typeIndex}）「{name}」：大小必须小于 {max} 字节，当前 {actual} 字节。",
    "minimum": "第 {index} 项（{type} {typeIndex}）「{name}」：{field}为 {actual}，最小要求 {min}。",
    "maximum": "第 {index} 项（{type} {typeIndex}）「{name}」：{field}为 {actual}，最大允许 {max}。",
    "codec": "第 {index} 项（{type} {typeIndex}）「{name}」：不支持{field} {actual}，允许：{allowed}。",
    "total_duration": "所选{type}总时长为 {actual} 毫秒，最大允许 {max} 毫秒。",
    "frames_first_required": "请先选择首帧，再选择尾帧。",
    "frames_ratio_mismatch": "首帧为 {firstWidth}×{firstHeight}，尾帧为 {lastWidth}×{lastHeight}，宽高比必须相同（像素尺寸可不同）。请更换其中一帧。",
    "audio_only": "当前模型不支持仅音频参考。请添加图片或视频、移除音频，或切换模型。",
    "pending": "第 {index} 项（{type} {typeIndex}）「{name}」：待服务端核验元数据。浏览器无法读取或未知数据不代表通过；播放失败不代表生成失败。",
    "fields": {
      "width": "宽度（像素）",
      "height": "高度（像素）",
      "ratio": "宽高比",
      "pixels": "像素总数",
      "duration_ms": "时长（毫秒）",
      "frame_rate": "帧率（fps）",
      "video_codec": "视频编码",
      "audio_codec": "音频编码"
    }
  },
  media: {
    reference_mode: '参考模式',
    scope_changed: '用户或团队已切换，请重新打开视频会话后继续。',
    "picker_title": "选择视频参考素材",
    "selected": "已选素材",
    "upload": "上传文件",
    "limits": "最多 {max} 项，每项不超过 50MiB。支持 PNG/JPEG/WebP、MP4/WebM/MOV、MP3/WAV/M4A/OGG。",
    "capability_notice": "参考类型能否用于生成取决于模型与供应商；不支持时会明确提示。",
    "image": "图片",
    "video": "视频",
    "audio": "音频",
    "all": "全部",
    "asset_library": "素材库",
    "filter": "筛选素材类型",
    "empty": "暂无此类型素材，可上传或加载更多。",
    "retry": "重试",
    "load_more": "加载更多",
    "cancel": "取消",
    "confirm": "确认选择",
    "remove_named": "移除 {name}",
    "preview_named": "预览 {name}",
    "unsupported_file": "文件格式不支持，请选择提示中列出的图片、视频或音频格式。",
    "file_too_large": "文件不能为空，且每项不能超过 50MiB。",
    "too_many": "最多选择 {max} 项参考素材。",
    "upload_failed": "{name} 上传失败，请重试；成功的文件已保留。",
    "first_frame": "首帧",
    "last_frame": "尾帧",
    "replace": "替换",
    "add": "添加参考",
     "reference_content": "参考内容",
    "reference_count": "{count} 项参考",
     "expand": "展开参考内容",
     "collapse": "收起参考内容",
     "clear_all": "清空全部素材",
     "reference_all_prompt_placeholder": "上传参考素材，输入文字，自由组合图、文、音、视频多元素。",
     "first_last_frame_prompt_placeholder": "输入文字，描述你想创作的画面内容、运动方式等。例如：一个3D形象的小男孩，在公园滑滑板。",
    "preview": "素材预览",
    "preview_unavailable": "预览不可用",
    "preview_failed": "素材预览暂不可用，请重试。",
    "loading": "正在加载预览…"
}
}
